/* BS COLLECTION — filter drawer + sort for the collection page (snippets/bs-filter-drawer.liquid,
   snippets/bs-collection-toolbar.liquid). Independent of the theme's .ltn__utilize drawers, so opening
   filters can never open the cart drawer. */
(function () {
  'use strict';
  if (window.__bsCollectionReady) return;
  window.__bsCollectionReady = true;

  var drawer = document.querySelector('[data-bs-filter]');
  var root = document.documentElement;

  /* ---------- Sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-bs-sort]');
    if (!sel) return;
    var parts = String(sel.value).split(':');
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by');
    url.searchParams.delete('view');
    if (parts[0] === 'view') url.searchParams.set('view', parts[1]);
    else url.searchParams.set('sort_by', parts[1]);
    window.location.href = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  });

  if (!drawer) return;

  var panel = drawer.querySelector('.bs-filter__panel');
  var form = drawer.querySelector('[data-bs-filter-form]');
  var body = drawer.querySelector('[data-bs-filter-body]');
  var countEl = drawer.querySelector('[data-bs-filter-count]');
  var nounEl = drawer.querySelector('[data-bs-filter-noun]');
  var applyBtn = drawer.querySelector('[data-bs-filter-apply]');
  var baseUrl = drawer.getAttribute('data-collection-url') || window.location.pathname;
  var snapshot = '', initialKey = '', lastFocus = null, reqId = 0, priceTimer = null;

  function params() {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (String(v).trim() !== '') p.append(k, v);
    });
    return p;
  }

  function syncChecked(scope) {
    Array.prototype.forEach.call((scope || body).querySelectorAll('.bs-opt'), function (l) {
      var i = l.querySelector('input');
      l.classList.toggle('is-checked', !!(i && i.checked));
    });
  }

  function setCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n)) return;
    countEl.textContent = n;
    if (nounEl) nounEl.textContent = n === 1 ? 'shirt' : 'shirts';
    applyBtn.disabled = n === 0;
  }

  function lock(on) {
    root.classList.toggle('bs-filter-lock', on);
  }
  /* Older iOS Safari ignores overflow:hidden for touch: block moves outside the scrolling body */
  document.addEventListener('touchmove', function (e) {
    if (!root.classList.contains('bs-filter-lock')) return;
    if (e.target.closest && e.target.closest('.bs-filter__body')) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });

  function open(trigger) {
    lastFocus = trigger || document.activeElement;
    snapshot = body.innerHTML;
    initialKey = params().toString();
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    lock(true);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bs-filter-open]'), function (b) { b.setAttribute('aria-expanded', 'true'); });
    syncChecked();
    var closeBtn = drawer.querySelector('.bs-filter__close');
    try { (closeBtn || panel).focus({ preventScroll: true }); } catch (_) { (closeBtn || panel).focus(); }
  }

  function close() {
    if (drawer.hidden) return;
    /* Not applied → put the drawer back the way it was */
    if (params().toString() !== initialKey) {
      body.innerHTML = snapshot;
      var tot = body.querySelector('[data-bs-filter-total]');
      if (tot) setCount(tot.textContent);
    }
    drawer.classList.remove('is-open');
    lock(false);
    Array.prototype.forEach.call(document.querySelectorAll('[data-bs-filter-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus(); } catch (_) {} }
  }

  /* Live result count: re-render the filter groups for the pending selection */
  function refresh() {
    var p = params();
    var id = ++reqId;
    var qs = p.toString();
    drawer.classList.add('is-loading');
    fetch(baseUrl + '?' + (qs ? qs + '&' : '') + 'section_id=bs-collection-filters', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (id !== reqId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-bs-facets-src]');
        if (!src) return;
        /* keep open/closed groups, focus and scroll position */
        var closed = {};
        Array.prototype.forEach.call(body.querySelectorAll('details[data-facet]'), function (d) { if (!d.open) closed[d.getAttribute('data-facet')] = true; });
        var a = document.activeElement, focusKey = null;
        if (a && body.contains(a) && a.name) focusKey = a.name + '|' + (a.type === 'checkbox' ? a.value : '');
        var top = body.scrollTop;
        /* price inputs being typed in are kept as they are */
        var typing = (a && a.matches && a.matches('[data-bs-price]')) ? { name: a.name, value: a.value } : null;
        body.innerHTML = src.innerHTML;
        Array.prototype.forEach.call(body.querySelectorAll('details[data-facet]'), function (d) { if (closed[d.getAttribute('data-facet')]) d.open = false; });
        if (typing) {
          var t = body.querySelector('input[name="' + typing.name.replace(/"/g, '\\"') + '"]');
          if (t) t.value = typing.value;
        }
        body.scrollTop = top;
        if (focusKey) {
          var parts = focusKey.split('|');
          var sel = 'input[name="' + parts[0].replace(/"/g, '\\"') + '"]' + (parts[1] ? '[value="' + parts[1].replace(/"/g, '\\"') + '"]' : '');
          var f = body.querySelector(sel);
          if (f) { try { f.focus({ preventScroll: true }); } catch (_) { f.focus(); } }
        }
        syncChecked();
        var tot = body.querySelector('[data-bs-filter-total]');
        if (tot) setCount(tot.textContent);
      })
      .catch(function () { /* keep the current counts; Apply still works */ })
      .then(function () { if (id === reqId) drawer.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bs-filter-open]');
    if (t) { e.preventDefault(); e.stopPropagation(); open(t); return; }
    if (drawer.hidden) return;
    if (e.target.closest('[data-bs-filter-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-bs-filter-clear]')) {
      e.preventDefault();
      Array.prototype.forEach.call(body.querySelectorAll('input[type="checkbox"]'), function (i) { i.checked = false; });
      Array.prototype.forEach.call(body.querySelectorAll('[data-bs-price]'), function (i) { i.value = ''; });
      syncChecked();
      refresh();
    }
  }, true);

  body.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"]')) { syncChecked(); refresh(); }
    else if (e.target.matches('[data-bs-price]')) { clearTimeout(priceTimer); refresh(); }
  });
  body.addEventListener('input', function (e) {
    if (!e.target.matches('[data-bs-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(refresh, 600);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var qs = params().toString();
    window.location.href = baseUrl + (qs ? '?' + qs : '');
  });

  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, select'), function (el) {
      return el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.BSFilter = { open: open, close: close };
})();
